module.exports = __webpack_public_path__ + "static/image2-15eec6fbd41da168e72667a1bcab6f0a.jpg";